import request from '@/utils/request'

/***获取入口 */
export function getEntranceData(data) {
    return request({
        url: '/GetEntrance',
        method: 'get',
        params: data
    })
}